import React from 'react';
import { useThemeContext } from 'src/context/ThemeProvider';

const CustomProgressSlider = ({
	value,
	sliderColor,
	bgColor,
	height = '16px',
	borderRadius = '10px',
	darkBgColor,
	darkSliderColor,
	maxValue,
}: {
	value: number;
	sliderColor: string;
	bgColor: string;
	height?: string;
	borderRadius?: string;
	darkBgColor?: string;
	darkSliderColor?: string;
	maxValue?: number;
}) => {
	const { themeMode } = useThemeContext();
	return (
		<div
			style={{
				width: '100%',
				height,
				background: themeMode === 'dark' && darkBgColor ? darkBgColor : bgColor,
				borderRadius,
			}}
		>
			<div
				style={{
					width: `${(value / (maxValue || 100)) * 100}%`,
					height: '100%',
					background: themeMode === 'dark' && darkSliderColor ? darkSliderColor : sliderColor,
					borderRadius,
				}}
			></div>
		</div>
	);
};

export default CustomProgressSlider;
